export const SHOULD_EXPAND_CATEGORIES = true;
export const POINTS_TRANSLATION_KEY = 'points';
